export const MOBILE_SWITCH_BREAKPOINT = 768;

export default () => {
  if(typeof(window.matchMedia) !== 'function') {
    return (window.innerWidth <= MOBILE_SWITCH_BREAKPOINT);
  } else {
    return window.matchMedia(`(max-width: ${MOBILE_SWITCH_BREAKPOINT}px)`).matches;
  }
}
